import { BASE_URL } from '@lib/constants';

/**
 * Track the usage click of a specific action
 */
export function trackUsageClick(type) {
	const usageUrl = `${BASE_URL}/wp-json/edu_api/reporting/usage/button` + '?type=' + type;

	fetch(usageUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).catch((error) => {
		console.log('There was an error updating reports');
		console.log(error);
	});
}

/**
 * Get all a tags and add outbound tracking to them
 */
export function addOutboundListener() {
	let links = document.querySelectorAll('a');

	links.forEach((link) => {
		let href = link.href;
		var currentLocation = window.location.hostname;

		if (href.includes('wearesmile')) {
			return;
		}

		if (href.includes(currentLocation)) {
			return;
		}

		const updateOutbound = `${BASE_URL}/wp-json/edu_api/reporting/prospectus/outbounds/update`;

		link.addEventListener('click', function () {
			fetch(updateOutbound, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			}).catch((error) => {
				console.log('There was an error updating the outbound count');
				console.log(error);
			});
		});
	});
}
